import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from './token.service';
import { environment } from '@environment';

// Environment placeholder (ensure this matches your environment file)
const CORE_API_BASE_URL = environment.coreApiBaseUrl;
const PUBLIC_KEY = environment.adminTenantPublicKey;

@Injectable({
  providedIn: 'root'
})
export class SmsService {
  private http = inject(HttpClient);
    private tokenService = inject(TokenService);

  /**
   * Sends a registration link via SMS to the specified user.
   * POST /sms/send-registration-link/{userId}
   */
  sendRegistrationLink(userId: string): Observable<boolean> {
    const url = `${CORE_API_BASE_URL}/sms/send-registration-link/${userId}`;
    const token = this.tokenService.getToken();

    const headers = new HttpHeaders({
      'Accept': 'application/json, text/plain, */*',
      'Authorization': `Bearer ${token}`,
      'x-public-key': PUBLIC_KEY,
      'x-token-ready': 'true'
    });

    return this.http.post<boolean>(url, {}, { headers });
  }
}